import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Box from '@material-ui/core/Box';
import useStyles from './styles';
import Bubble from '../Charts/Bubble';
import Search from '../Search/Search';

import TranslationTxt from '../TranslationTxt/TranslationTxt';

const BubbleSection = ({ header, text }) => {
  const [toggle, setToggle] = useState('race');

  const handleToggle = (event, newToggle) => {
    setToggle(newToggle);
  };

  const classes = useStyles();
  return (
    <div className="section" style={{ marginTop: 50 }}>
      <Typography variant="h3" className={classes.header}>
        <TranslationTxt measure={header} />
      </Typography>
      <Typography variant="body1" className={classes.text}>
        <TranslationTxt measure={text} />
      </Typography>
      <Box className={classes.filter}>
        <Box className={classes.filterBy}>
          <Typography variant="body1" className={classes.toggleText}>
            <TranslationTxt measure="=Only({<Index = {21}>}[$(vLanguage)])" />
          </Typography>
          <ToggleButtonGroup
            value={toggle}
            exclusive
            onChange={handleToggle}
            aria-label="filter by"
            className={classes.toggles}
          >
            <ToggleButton value="race" aria-label="race" className={classes.toggleItem}>
              <Typography variant="body1" className={classes.toggleLabel}>
                <TranslationTxt measure="=Only({<Index = {22}>}[$(vLanguage)])" />
              </Typography>
            </ToggleButton>

            <ToggleButton value="gender" aria-label="gender" className={classes.toggleItem}>
              <Typography variant="body1" className={classes.toggleLabel}>
                <TranslationTxt measure="=Only({<Index = {23}>}[$(vLanguage)])" />
              </Typography>
            </ToggleButton>

          </ToggleButtonGroup>
        </Box>

        <Search footnote dimension="[Name of media outlet for search - 2022]" />

      </Box>
      <Bubble mixby={toggle} />
    </div>
  );
};

BubbleSection.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
};

BubbleSection.defaultProps = {
  header: '',
  text: '',
};

export default BubbleSection;
